import { Text } from '@simplywallst/ui-core';
import { StyledGrid } from './styled';

export const EmptyState = () => (
  <StyledGrid placeContent="center" gap="4px">
    <Text typography="xSmall" color="white" textAlign="center">
      No data currently available
    </Text>
    <Text typography="tiny" color="whiteRGBA" opacity={0.5} textAlign="center">
      Please try again later
    </Text>
  </StyledGrid>
);
